<template>
  <div class="site-status-history-table">
    <v-card>
      <v-card-title>
        상세 데이터
        <v-spacer/>
        <v-icon v-if="layoutInformation.statusHistoryOpened" @click="toggleStatusHistory">expand_less</v-icon>
        <v-icon v-else @click="toggleStatusHistory">expand_more</v-icon>
      </v-card-title>

      <div v-if="layoutInformation.statusHistoryOpened">
        <v-card-text class="text--primary" v-if="siteStatus.length > 0">
          [{{siteStatus[0].siteId}}] {{ siteStatus[0].name }} / {{ siteStatus[0].address }} / {{ siteStatus[0].cdmaNumber }}
        </v-card-text>
        <v-card-text class="text--primary" v-else>
          데이터가 없습니다.
        </v-card-text>

        <!-- TODO : 여기서도 적당히 n개만 받아올 수 있어야 함 -->
        <v-data-table :headers="headers" :items="siteStatus" :items-per-page="10"
                      :search="search"
                      multi-sort
                      hide-default-footer
                      :page.sync="page"
                      @page-count="pageCount = $event"
                      class="elevation-1 ma-2">
          <template v-slot:item.timestampString="{ item }">
            {{ printReadableTimestamp(item.timestampString) }}
          </template>

          <template v-slot:item.hasNoError="{ item }">
            <td>
              <div v-if="item.hasNoError">
                <v-chip class="ma-1" color="green" text-color="white">정상</v-chip>
              </div>
              <div v-if="item.undergroundWaterError">
                <v-chip class="ma-1" color="red" text-color="white">FLOAT</v-chip>
              </div>
              <div v-if="item.overloadError">
                <v-chip class="ma-1" color="red" text-color="white">EOCR</v-chip>
              </div>
              <div v-if="item.electricWaveError">
                <v-chip class="ma-1" color="red" text-color="white">전파 이상</v-chip>
              </div>
            </td>
          </template>

          <template v-slot:item.motorRun="{ item }">
            <v-icon class="mr-2" color="green" v-if="item.motorRun">fas fa-circle-notch fa-spin</v-icon>
            <v-icon class="mr-2" color="red" v-else>block</v-icon>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" total-visible="10" color="blue-grey darken-2"/>

        <v-card-actions>
          <v-spacer/>
          <v-dialog v-model="dialog.excelDownloadRangeDialog" width="800">
            <SiteStatusExcelDownloadRangeDialog :dialog="dialog"
                                                :siteStatus="siteStatus"
                                                :dateRange="dateRange"/>
            <template v-slot:activator="{ on }">
              <v-btn text @click="dialog.excelDownloadRangeDialog = !dialog.excelDownloadRangeDialog" v-on="on">
                <v-icon>fa-file-download</v-icon>&nbsp;엑셀 다운로드
              </v-btn>
            </template>
          </v-dialog>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  import SiteStatusExcelDownloadRangeDialog from "./SiteStatusExcelDownloadRangeDialog";

  export default {
    name: 'siteStatusHistoryTable',
    components: {
      SiteStatusExcelDownloadRangeDialog
    },
    props: {
      siteStatus: {
        type: Array,
        required: true
      },
      layoutInformation: {
        type: Object,
        required: true
      },
      dateRange: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        page: 1,
        pageCount: 0,
        search: '',
        headers: [
          {text: '시각', value: 'timestampString'},
          {text: '현장상태', value: 'hasNoError', align: 'start', width: "200px"}, // TODO : 이 부분 폼팩터 작아지면 글자 밀리므로 확인...
          {text: '모터동작', value: 'motorRun'},
          {text: '수위', value: 'waterLevel'},
          //{text: '오늘 유입량', value: 'inflowToday'},
          //{text: '총유입량', value: 'inflowTotal'},
          //{text: '약품 수위', value: 'chemicalLevel'},
          //{text: '일일물량 부족횟수', value: 'todayFloatError'},
        ],
        dialog: {
          excelDownloadRangeDialog: false
        }
      }
    },
    methods: {
      toggleStatusHistory() {
        this.layoutInformation.statusHistoryOpened = !this.layoutInformation.statusHistoryOpened;
        $cookies.set('siengLayoutInformation', this.layoutInformation, '1825d');
      },
      downloadExcel() {
        const retryFuncBackup = this.downloadExcel.bind(this);

        const endTimestamp = moment(`${this.dateRange.endDate}T${this.dateRange.endTime}`).valueOf();
        const startTimestamp = moment(`${this.dateRange.startDate}T${this.dateRange.startTime}`).valueOf();

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteStatus/${this.siteStatus[0].siteId}/_excel?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          },
          responseType: 'blob'
        };

        axios.get(targetUri, config)
          .then(result => {
            console.log('excel download');
            console.dir(result);
            let fileName = result.headers["content-disposition"].split("filename=")[1];
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE인 경우에
              window.navigator.msSaveOrOpenBlob(new Blob([result.data],
                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                fileName);
            } else {
              const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', result.headers["content-disposition"].split("filename=")[1]);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      printReadableTimestamp(timestampString) {
        if (!timestampString) {
          return '';
        }
        return timestampString.replace('T', ' ').replace('+09:00', '');
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      }
    }
  }
</script>